import { API } from '@Providers';

export interface EquipmentRentalLineCheckoutPayload {
  line_id: string;
  rental_agreement_id?: string | null;
  due_date?: string;
  rental_notes?: string;
  rental_start_date?: string;
  agreement_title?: string;
  agreement_body?: string;
}

interface CompleteEquipmentRentalManualCheckoutPayload {
  cart_id: string;
  equipment_rental_lines?: EquipmentRentalLineCheckoutPayload[];
}

export default async function (payload: CompleteEquipmentRentalManualCheckoutPayload) {
  const endpoint = '/api/shelter/cart/complete-equipment-rental-manual-checkout';

  return API({ endpoint, method: 'post', payload });
}
